import React, { useEffect } from 'react';
import '../../styles/components/AboutMe.css';
import Chidrupa_img from '../assets/Chidrupa_img.png';
import Navbar from '../layout/Navbar';
import { useViewMode } from '../../utils/viewMode';

const AboutMe = () => {
    const [mode] = useViewMode();

    // Flip the App-level pastel gradient to flat GitHub-dark while
    // this page is mounted in dev mode. The gradient lives on .App
    // via radial-gradient layers, so a background-color override on
    // body has no effect. Instead we add a class to body that a CSS
    // rule in App.css targets to override .App's background entirely.
    useEffect(() => {
        if (mode !== 'developer') return undefined;
        document.body.classList.add('dark-canvas');
        return () => document.body.classList.remove('dark-canvas');
    }, [mode]);

    return (
        <div className={`AboutMe ${mode === 'developer' ? 'AboutMe--dev' : ''}`}>
            <Navbar />

            <div className="about-content">
                <div className="about-text-section">
                    <div className="text-content">
                        <div className="about-image-section">
                            <div className="image-container">
                                <img src={Chidrupa_img} alt="Chidrupa Mamunooru" />
                                <div className="image-overlay"></div>
                            </div>
                        </div>

                        <p className="intro-text">
                            <strong>Hi, I'm Chidrupa.</strong> I'm a <strong>Product Builder</strong> — designer, engineer, and AI-first thinker. I've spent 5+ years designing and shipping products in technical, domain-heavy spaces, and I came to design from the other side, as an engineer.
                        </p>

                        <p>
                            I started as a frontend developer at <strong>Deloitte</strong>, building dashboards and watching design files float past me. I kept finding things I'd change in those files — "this might create a better experience," or "this won't scale how you think it will." Eventually I realized I was more excited about the design than the development. So I went to <strong>Arizona State</strong> for a master's in Human-Computer Interaction and crossed over.
                        </p>

                        <p>
                            Most recently at <strong>Bally's Interactive</strong> (NAI), where I was the sole product designer across <strong>Bally Bet Sports & Casino</strong> and <strong>Monopoly Sports & Casino</strong>. I led end-to-end design of <strong>Pick'em</strong>, a flagship free-to-play product that scaled across NFL, MLB, and FIFA World Cup — serving roughly 5,000 weekly users and supporting ~$3M in wagering. Along the way I ended up leading a small team of contract designers and pioneering AI-first workflows for the team.
                        </p>

                        <p>
                            Before Bally's, I was at <strong>Schrödinger</strong> as the dedicated UX designer for <strong>LiveDesign</strong> and <strong>Maestro</strong> — computational chemistry tools used in drug discovery. Coming in with high school chemistry, I leaned into asking the right questions and sitting with scientists for hours to design things like the kinase selectivity panel and crystal structure prediction viewer. I also built the LiveDesign design system from scratch, which became the foundation for all future design work there.
                        </p>

                        <p>
                            Earlier, I was a UX researcher at <strong>Arizona State University</strong> and a design intern at <strong>OurDate</strong>, where I learned the unforgettable lesson that you can't reinvent every wheel.
                        </p>

                        <p>
                            <strong>What I'm thinking about now:</strong> AI is reshaping what "designer" means — and I think designers should evolve, not defend. I'm leaning into business strategy, technical fluency, and AI-first workflows. The chat agent on the homepage? That's me practicing what I preach.
                        </p>

                        <p>
                            <strong>How I work:</strong> I'm a sucker for getting the basics right. I can't start designing until I understand the problem deeply. I default to first-principles questions, work closely with engineers, and care more about whether something actually shipped than whether the screens looked beautiful in Figma. My toolbox right now: Figma, FullStory, Google Analytics, Jira, Claude MCP, Lottie — and a habit of reading code repos when something feels off.
                        </p>

                        <p>
                            <strong>Outside work,</strong> I'm a serial deep-diver across hobbies. Painting, watercolors, sketching, air-dry clay trinkets, cooking from my mom's and aunts' recipes, Starbucks mug collecting (the Discovery and Been-There series), and writing travel itineraries for places I haven't been yet. I read a book in four days when I'm in a phase. I've lived in Hyderabad → Arizona → New Jersey, and I love both city energy and quiet.
                        </p>

                        <div className="contact-section">
                            <p>
                                Want to chat? Talk to my AI agent on the <a href="/" className="email-link">homepage</a>, or reach me directly at{' '}
                                <a href="mailto:mchidrupa01@gmail.com" className="email-link">
                                    mchidrupa01@gmail.com
                                </a>.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutMe;
